import * as React from 'react';
import Popover, {PopoverProps} from '@material-ui/core/Popover';
import connectWithRouter from '../../../../../shared/components/redux/connectWithRouter';
const PopoverFromTop: React.StatelessComponent<PopoverProps> = ({style, open, id, ...props}) => {
  return (
    <Popover
      anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
      transformOrigin={{horizontal: 'left', vertical: 'top'}}
      PaperProps={{style, id}}
      open={open}
      {...props}
    />
  );
};
// noinspection JSUnusedGlobalSymbols
export default connectWithRouter()(PopoverFromTop);
